import { createMetricsFactory } from 'metrics-js';

export const Metrics = createMetricsFactory('hubspot-apollo-cache');
